import styled from 'styled-components';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';

export const HeaderContainer = styled.div`
	border-bottom: 1px solid ${defaultTheme.v3.colors.gray[4]};
	padding: 0.5rem 0.5rem 0 0.5rem;
`;
